module.exports = __webpack_public_path__ + "media/packs/images/flags/AS-ae4fbec6205c27822178303645d38a03.png";